import Link from 'next/link';

import { useMemo } from 'react';

import { css } from '@emotion/react';

import { palette } from '@lib/styles/palette';

import Icon from '@components/common/Icon';

interface NoResultProp {
  recommendKeywords: string[];
}

function NoResult({ recommendKeywords }: NoResultProp) {
  const splitKeywordArray = useMemo(() => {
    const filterArray: { list: string[]; id: number }[] = [];
    const copiedArray = [...recommendKeywords];
    const maxLength = 5;

    let reps = 0;
    while (copiedArray.length > 0) {
      filterArray.push({ id: reps, list: copiedArray.splice(0, maxLength) });
      reps += 1;
    }

    return [...filterArray];
  }, [recommendKeywords]);

  return (
    <div css={noResultStyle}>
      <div className="noresultContainer">
        <Icon icon="noResult" />
        <h2>
          검색한 상품 시세는 준비중입니다.
          <br /> 빠르게 확인 드릴 수 있도록 노력하겠습니다!
        </h2>
        <div className="divider" />
        <div className="recommendArea">
          <h3>이 상품 시세조회 어때요?</h3>
          <p>요즘 인기있는 시세조회 키워드 입니다.</p>
          <div className="recommendButtonContainer">
            {splitKeywordArray.map(({ id, list }) => {
              return (
                <div className="slider" key={id}>
                  {list.map((keyword) => {
                    return (
                      <div key={keyword} className="box">
                        <Link href={`/search-price?searchWord=${keyword}`}>
                          <a className="recommendButton">{keyword}</a>
                        </Link>
                      </div>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

const noResultStyle = css`
  min-height: 500px;
  /* display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column; */

  .noresultContainer {
    padding-top: 55px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  h2 {
    display: block;
    text-align: center;
    margin-top: 20px;
    line-height: 20px;
    font-size: 14px;
  }

  .divider {
    width: 100%;
    height: 4px;
    background-color: ${palette.gray0};
    margin-top: 30px;
  }

  .recommendArea {
    margin-top: 24px;
    padding: 0 0 0 20px;
    align-self: flex-start;
    max-width: 100vw;
  }

  h3 {
    font-size: 20px;
    font-weight: 500;
    line-height: 22px;
  }

  h3 + p {
    margin-top: 4px;
    font-size: 14px;
    line-height: 22px;
  }

  .recommendButtonContainer {
    display: flex;
    flex-wrap: wrap;
    margin-top: 5px;
    flex-direction: row;
    max-width: 100%;
  }

  .slider {
    display: flex;
    flex-wrap: nowrap;
    overflow: auto;
    scroll-snap-type: x mandatory;
    -ms-overflow-style: none;

    ::-webkit-scrollbar {
      display: none;
      width: 0 !important;
    }
  }

  .box {
    display: inline-block;
    padding-right: 5px;
    cursor: pointer;
    flex: 1 0 auto;
  }

  .recommendButton {
    border: 1px solid ${palette.gray2};
    color: ${palette.black10};
    padding: 0 12px;
    box-sizing: border-box;
    display: inline-flex;
    justify-content: center;
    border-radius: 4px;
    margin-top: 5px;
    font-size: 14px;
    height: 32px;
    line-height: 30px;
  }

  .recommendButton:hover {
    color: ${palette.black10};
  }
`;

export default NoResult;
